import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type ReadMassSignatureDto } from "../dto/mass-signature.dto";
import { type EnhanceOptions } from "../dto/enhance-signature.dto";

export class MassSignatureApi {
  private baseEndpoint = "/mass-signature/";

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  async start(letterFiles: number[], pades: boolean, enhanceOptions?: EnhanceOptions) {
    const response = await this.network.post(this.baseEndpoint, {
      letterFiles,
      pades,
      enhanceOptions,
    });
    return response.data;
  }

  async getMine(): Promise<ReadMassSignatureDto | null> {
    const response = await this.network.get(this.baseEndpoint);

    if (response.status === 204) {
      return null;
    }

    return response.data;
  }

  async getMassSignatureSummary(letterFiles: number[]): Promise<ReadMassSignatureDto> {
    const response = await this.network.post(`${this.baseEndpoint}summary`, {
      letterFiles,
    });
    return response.data;
  }

  async complete(next: boolean) {
    const response = await this.network.post(`${this.baseEndpoint}complete`, {
      next,
    });
    return response.data;
  }
}

export const [massSignatureApiToken, useMassSignatureApi] = useClassFactory(MassSignatureApi);
